module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB2001-effe5aec484364f76f6fe65eee4702e6.png";